import React from 'react';
import { faSnowflake } from '@fortawesome/pro-solid-svg-icons/faSnowflake';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function SnowflakeSolidIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faSnowflake} {...props} />;
}
